import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/content';
function Stars({
  rating
}: {
  rating: number;
}) {
  return <div className="flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`} data-id="element-86" data-mp="2hcvx947g9a31">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`h-3.5 w-3.5 ${star <= rating ? 'fill-gold-400 text-gold-400' : 'text-cream-300'}`} aria-hidden="true" data-id="element-87" data-mp="2ras6trkqnwz1" />)}
    </div>;
}
export function Reviews() {
  return <section className="px-6 py-12" data-id="element-88" data-mp="309ndf4rp392v">
      <div className="text-center" data-id="element-89" data-mp="352ghrrj94fef">
        <p className="font-display text-[44px] font-semibold leading-none tracking-[-0.02em] text-ink-900" data-id="element-90" data-mp="353hstw09p1w5">
          4.8
        </p>
        <div className="mt-3 flex justify-center" data-id="element-91" data-mp="3a3du3nhkyf80">
          <Stars rating={5} data-id="element-92" data-mp="3f1ff4dykgom4" />
        </div>
        <p className="mt-3 text-[15px] text-ink-500" data-id="element-93" data-mp="3ey9qt0xrhqrg">
          Based on reviews from parents across Latin America
        </p>
      </div>

      <ul className="mt-8 space-y-3" data-id="element-94" data-mp="2rd6z07xn04pr">
        {reviews.map(review => <li key={review.name} className="rounded-2xl border border-cream-300 bg-white p-5" data-id="element-95" data-mp="2mdkklv62oifd">
            <div className="flex items-center gap-3" data-id="element-96" data-mp="2mfxaqvlzhz3i">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cream-200 font-display text-[15px] font-semibold text-ink-800" aria-hidden="true" data-id="element-97" data-mp="2hf99zi7ye3w3">
                {review.name.charAt(0)}
              </span>
              <div className="flex-1" data-id="element-98" data-mp="3553l9vcmjke8">
                <p className="font-display text-[16px] font-semibold leading-tight text-ink-900" data-id="element-99" data-mp="35659z2mkc5ef">
                  {review.name}
                </p>
                <p className="mt-0.5 text-[13px] text-ink-500" data-id="element-100" data-mp="2wcju1fynwi3f">{review.country}</p>
              </div>
              <Stars rating={review.rating} data-id="element-101" data-mp="3stwjxzkms6cj" />
            </div>
            <p className="mt-3.5 text-[15.5px] leading-[1.65] text-ink-800" data-id="element-102" data-mp="3o2y4113k1a9t">{review.text}</p>
          </li>)}
      </ul>
    </section>;
}